import { sortBy } from 'lodash'

// Order is more or less based on the ASCII table: https://www.asciitable.com/
// 1. Most other characters
// 2. Numbers
// 3. Uppercase letters
// 4. Lowercase letters
export const sortAscending = <
  T extends Array<Record<K, string>>,
  K extends keyof T[number],
>(
  list: T,
  key: K
): T => {
  return sortBy(list, (item) => {
    const number = parseInt(item[key]) // if begins with a number even zero padded like 08 vs. 12
    return isNaN(number) ? item[key].charCodeAt(0) : number
  }) as T
}
